<template>
  <article class="careers">
      <!--海报-->
      <section class="banner container-fluid">
            <img src="../../../static/img/join-bg.jpg" alt="">
            <div class="title">
              <p class="p1">CAREERS</p>
              <p class="p2">追梦路上，有你同行</p>
            </div>
      </section>

    <!--招聘标题-->
    <section class="job">
      <div class="title text-center">
        <h3 class="text-center">最新招聘信息</h3>
      </div>
    </section>

    <div class="container">
      <!--招聘列表-->
      <div class="job-list" v-for="v in careers">
          <div class="j-header clearfix" @click="toggleShow($event)">
              <div class="pull-left job-name">
                  <p>{{v.title}}</p>
                  <p>{{v.sub_title}}</p>
                  <p class="info">
                    <span class="s1">部门：{{v.dep}}</span> 招聘人数：<span class="s2">{{v.user_cnt}}人</span></p>
              </div>
              <div class="pull-right arrow"><i class="glyphicon glyphicon-menu-down"></i></div>
          </div>
          <div class="content" style="display:none">
                <p>职位描述：</p>
                <ul>
                  <li v-for="(x, idx) in v.desc" >{{idx + 1}}、{{x}}</li>
                </ul>
                <p>岗位要求：</p>
                <ul>
                  <li v-for="(x, idx) in v.req" >{{idx + 1}}、{{x}}</li>
                </ul>
          </div>
      </div>

    </div>
  </article>
</template>

<script>
  export default {
    data() {
      return {
        activeIndex: 0,
        invite:{
          first_card:{
            sketch:[],
            particulars:[]
          }
        },
        careers: [
            {
                title: '游戏策划',
                sub_title: 'Game Planner',
                dep: '产品部',
                user_cnt: '1',
                desc: [
                    '负责游戏内关卡的玩法设计',
                    '制作关卡，根据测试数据，调整关卡节奏，提升关卡留存及时长',
                    '搭建系统架构和数值框架，包含玩法、经济、养成、装扮等功能的定位及数值设定',
                ],
                req: [
                    '本科及以上学历，985院校学历背景优先考虑',
                    '1-2年游戏策划经验，有完整的项目执行经验，对经典的休闲游戏，小游戏玩法机制有一定的研究了解，具备以用户视角设计体验的思维模式',
                    '能很好的把控关卡阻碍、解法、反馈、剧情以及视觉美感，使用户达到所需的心流体验状态',
                    '热爱游戏行业，游戏经验丰富，至少对五款以上主流的游戏有深刻理解',
                    '具备较强的学习能力和沟通能力',
                ],
            },
            {
                title: '游戏美术',
                sub_title: 'Game Artist',
                dep: '产品部',
                user_cnt: '1',
                desc: [
                    '独立完成符合风格质量的欧美卡通游戏的角色动作表情的设计及细化',
                    '独立完成符合风格质量的游戏故事插图',
                    '熟练使用AI工具',
                ],
                req: [
                    '1-3年以上游戏行业原画经验',
                    '美术专业出身，有较强的美术基础',
                    '在游戏原画设计领域拥有丰富的经验，特别是欧美Q版风格设计',
                    '精通绘画软件和工具，如Adobe Photoshop、Corel Painter等',
                    '能够快速理解和转化游戏设计需求为视觉表现，具备良好的创意和构图能力',
                    '具备良好的沟通合作能力，能够与团队成员紧密配合，共同完成项目目标',
                ],
            },
            {
                title: 'Unity开发',
                sub_title: 'Development',
                dep: '研发部',
                user_cnt: '1',
                desc: [
                    '使用Unity3D研发iOS/Android平台的休闲手游',
                    '负责Unity3D程序架构与性能优化',
                    '负责调研新技术，提出解决方案以满足新需求',
                    '负责项目团队培训和管理，积极帮助伙伴成长',
                ],
                req: [
                    '本科学历，计算机相关专业，熟悉Unity3D引擎架构设计，5年以上Unity3D 开发经验',
                    '熟悉Unity常见实用插件；熟悉C#及常用的数据结构与算法',
                    '了解图形学基础，熟悉unity shader的编写，根据项目需求完成功能的开发和维护',
                ],
            },
            {
                title: '游戏测试',
                sub_title: 'Game Testing',
                dep: '测试部',
                user_cnt: '1',
                desc: [
                    '对产品需求进行评审，能从各角度全面分析需求设计的遗漏点和风险点，并独立设计测试点与测试用例',
                    '熟悉市场上同类产品，能从中提取出有效信息，提出优化建议，完善游戏体验系统',
                    '负责游戏核心功能模块的测试工作，推进测试中的问题解决，及时汇报和反馈进度风险',
                    '督促和协助开发人员尽快的解决程序中的缺陷，有独立走位问题的能力',
                ],
                req: [
                    '3年及以上游戏测试经验，软件工程类、电子信息类、计算机科学等相关专业背景，有经历过完整项目研发上线并持续跟进运营版本者优先',
                    '熟悉测试流程，能发现流程中的问题，并及时汇报',
                    '善于联想，注重细节，能准确定位到游戏功能的关联系统，并分析出可能产生的风险点',
                    '能在日常测试中总结出各种异常情况，用于未来测试的风险排查',
                    '有较强的沟通交流能力，能独立与产品部门对齐需求，并跟进问题的解决',
                    '了解一定专项测试流程，如性能、兼容性、网络等',
                ],
            },
            {
                title: '游戏开发工程师',
                sub_title: 'Game Developer',
                dep: '研发部',
                user_cnt: '1',
                desc: [
                    '使用Cocos2d-x引擎进行iOS/Android平台手机海外休闲游戏开发',
                    '与策划，美术保持良好的沟通，确保程序功能与设计需求一致',
                    '独立实现游戏各个场景，包括但不限于核心玩法、商店等',
                    '对游戏性能优化有一定经验，包括但不限于UI，物理引擎、内存管理等',
                ],
                req: [
                    '计算机相关专业本科或以上学历，3-5年开发经历',
                    '深入理解OOP，熟悉常见的设计模式、多层架构',
                    '熟练掌握C++开发技术',
                    '热爱软件事业，具有良好的团队协作和沟通能力，有高度的责任心，勇于接受挑战',
                    '具备cocos2dx和untiy开发经验者优先',
                    '有游戏编程作品展示或者有游戏公司从业经验者优先',
                ],
            },
        ],
      }
    },
    methods:{
        toggleShow(event){
            if (!event) {
                return;
            }
            let currentTarget = event.currentTarget;
            $(currentTarget).next().slideToggle();
            
        }
    },
    mounted(){
        this.toggleShow();
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
  .careers {
    .orange {
      color: #ff9d01;
    }
        // 海报
        .banner {
            padding:0;
            position: relative;
      background-color: #2b292a;
      img {
        display:block;
        margin:0 auto;
        max-width:1920px;
      }
            .title {
                position: absolute;
                text-align: center;
                top:50%;
                left:50%;
                transform:translate(-50%,-50%);
                color:#fff;
                font-size:38px;
                .p2 {
                    font-size:24px;
                }
                @media screen and (max-width:767px){
                    font-size:4vw;
                    .p2 {
                        font-size:3vw;
                    }
                }
             }
        }
    // 招聘标题
    .job {
      .title {
        padding: 75px 0 60px;
        border-bottom: 1px solid #eee;
        h3 {
          text-align: center;
          padding-bottom: 25px;
          font-size: 30px;
          position: relative;
          &:after {
            content: "";
            width: 80px;
            height: 3px;
            background: #ff9a24;
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
          }
        }
      }
      // 适配手机
      @media screen and (max-width:414px) {
        .title{
          padding: 25px 0 10px;
        }
        .title h3 {
          font-size:22px;
        }
      }
    }
    // 招聘列表
    .job-list {
          padding-bottom:22px;
          padding-top:10px;
          border-bottom:1px solid #e7e7e7;
        .j-header {
          color:#444444;
          cursor:pointer;
           .job-name {
              font-size:22px;
              p.info {
                font-size:15px;
                span.s1 {
                   padding-right:20px;
                }
                span.s2 {
                   color:#fb9934;
                }
              }
           }
           .arrow {
              font-size:30px;
              color:#696969;
           }
           
        }
        .content {
          overflow: hidden;
           p {
             margin-top:12px;
           }
        }
        // 适配手机
        @media screen and (max-width:414px) {
           .j-header .job-name {
              font-size:16px;
                p.info {
                  font-size:12px;
                }
            }
           .j-header .arrow {
              font-size:20px;
           }
        }
    }
    

  }
</style>



// WEBPACK FOOTER //
// src/components/home/careers.vue